import React from 'react';
import { rechtlichesData } from '@/data/mock';

const Footer = ({ onNavigate }) => {
  const links = [
    { id: 'impressum', label: 'Impressum' },
    { id: 'datenschutz', label: 'Datenschutzerklärung' },
    { id: 'rechtliches', label: 'Rechtliche Hinweise' }
  ];

  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 bg-[#0a140a] border-t border-[#D4AF37]/20 px-5 py-10 md:px-16"
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-6 text-center">
        {/* Brand */}
        <div>
          <h3 className="text-2xl font-light text-white tracking-wide" style={{ fontFamily: "'Cormorant', serif" }}>
            Green Living
          </h3>
          <p className="text-xs text-[#F4E4C1]/50 font-light tracking-wide mt-1">Leben am Wasser · Berlin-Schmöckwitz</p>
        </div>

        {/* Legal links */}
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {links.map((link) => (
            <button
              key={link.id}
              data-testid={`footer-${link.id}`}
              onClick={() => onNavigate && onNavigate(link.id)}
              className="text-sm text-white/60 hover:text-[#D4AF37] transition-colors font-light tracking-wide"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* Copyright */}
        <p className="text-xs text-white/35 font-light leading-relaxed max-w-2xl">
          {rechtlichesData.copyright}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
